
import {dollarToString} from "../../../lib/currency-utils";
import {AccountDerivedState, AccountState, AccountTypeLabel, PortfolioPerforamnceType, PortfolioPerformanceLabel,REBALANCE_OP} from "../../../lib/constants";
import {sprintf} from "sprintf-js";
import {Action, Info, TextLoading} from "../../funcs/utils";
import {DashboardTable} from "../dashboard-table";
import React from "react";
import {Popup, PopupBorder} from "../../../lib/onboarding-shared/popup";
import {OptionPopupMenu} from "../BannerMenu/OptionPopupMenu";
import {AddUserErrorModal, AddUserModal} from "./add_user_modal";
import {AdminDashboardView} from "../../../lib/dashboard-constants";
import {
  ONOBARDING_DATA_COLUMNS,
  REBALANCE_REQUESTED_DATA_COLUMNS,
  DEFAULT_DATA_COLUMNS,
  SORTABLE_COLS
} from "./wlf-user-table-data-columns";
import {is_development_mode} from "../../helper/execute-mode";
import {deep_copy, string_cmp} from "../../../lib/js-utils";
import RenderEdit from "../RenderEdit/RenderEdit";

const state_to_color = state => {
  if (state === AccountDerivedState.ONBOARDING) {
    return "#00F";
  } else if (state === AccountDerivedState.ALLOCATED) {
    return "#218721";
  } else if (state === AccountDerivedState.ACCOUNT_TRANSFER
    || state === AccountDerivedState.ACCOUNT_PENDING) {
    return "#000";
  } else if (state === AccountDerivedState.REBALANCE_REQUESTED) {
    return "#F00";
  }
  return "#000";
}

const isInBand = portfolio_performance_type => {
  return portfolio_performance_type === PortfolioPerforamnceType.IN_BAND.value
}

const portfolio_performance_to_color = portfolio_performance_type => {
  if (isInBand(portfolio_performance_type)) {
    return "#008000";
  }
  return "#FF0000";
}

const isAdjustable = (accountState) => {
    const isAdjustAbleAccountStates = [AccountState.TEST_PORTFOLIO, AccountState.TDA_PORTFOLIO, AccountState.RIA_PORTFOLIO, AccountState.BROKERAGE_PORTFOLIO];

    return isAdjustAbleAccountStates.includes(accountState);
}

const render_popup = (component, buttons, menu_id) => {
  const popup_style = {
    marginTop: "1px",
    transform: "translate(-0.5rem, 0)",
  }
  const button_style = {
    padding: "0 0.5rem",
  }
  const client = {
    color: {
      background: { r: 255, g: 255, b: 255 },
      text: { r: 0, g: 0, b: 0 },
      mode: "light",
    }
  }

  return (
      <Popup style={popup_style}
            onMouseOver={component.onMouseOver}>
        <PopupBorder>
          <OptionPopupMenu
            menu_id={menu_id}
            style={button_style}
            client={client}
            buttons={buttons}/>
        </PopupBorder>
      </Popup>
  )
}

const ACCT_DELETABLE = acct_state => {
  return acct_state === AccountState.ONBOARDING
    || acct_state === AccountState.ONBOARDING_PROXY
    || acct_state === AccountState.HALF_SIGNED
    || acct_state === AccountState.SIGNED
    || acct_state === AccountState.LIVE;
}

const maybe_render_wlf_popup = (component) => {
  if (!component.state.show_admin_wlf_menu) {
    return null;
  }
  
  const buttons = [
    { id: AdminDashboardView.all, label: "All" },
    { id: AdminDashboardView.live, label: "Live" },
    { id: AdminDashboardView.rebalance, label: "Rebalance Requested" },
    { id: AdminDashboardView.onboarding, label: "Onboarding" },
    { id: AdminDashboardView.not_funded, label: "Not Funded" },
    { id: AdminDashboardView.password_not_set, label: "Password Not Set" },
    { id: AdminDashboardView.onboarding_stale, label: "Stale Over 30 Days" },
  ];

  return render_popup(component, buttons, "admin_wlf_menu");
}

const maybe_render_popup = (component, wlf_item, item_index) => {
  if (item_index !== component.state.show_menu) {
    return null;
  }

  const is_proxy_onboarding = wlf_item.items[item_index].account_state
    === AccountState.ONBOARDING_PROXY;

  const isShowAdjust = isAdjustable(wlf_item.items[item_index].account_state);

  const buttons = [
    { id: "dashboard", label: "User Dashboard", disable: false },
    { id: "alloc", label: "Initial Allocation", disable: true },
    { id: "onboarding", label: "Onboarding" },
    { id: "rebalance", label: "Rebalance" },
    { id: "rebalance-MTW", label: "Rebalance - MTW" },
    { id: "fees", label: "Fees" },
    { id: "payments", label: "Payments" },
    { id: "documents", label: "Documents" },
    { id: "personal", label: "Personal Information" },
    { id: "add_account", label: "Add Account" },
    { id: "proxy_onboarding", label: "Proxy Onboarding", disable: !is_proxy_onboarding },
  ];

  if(isShowAdjust) {
    buttons.push({ id: "adjust_time", label: "Adjust Time"},{ id: "adjust_risk", label: "Adjust Risk" });
  }

  return render_popup(component, buttons, "user_menu");
}

// Collect all account indices for this user.
const collect_user_indices = (component, wlf_item, item_index) => {
  const result = [];
  const item = wlf_item.items[item_index];
  const num_accounts = item.user.accounts.length;
  const acct_index = item.acct_index;
  for(let i=0; i < num_accounts; i++) {
    result.push(item_index - acct_index + i);
  }
  return result;
}

// Return true if all account items are either ONBOARDING or LIVE state
const can_delete_user_fn = (component, wlf_item, indices) => {
  let result = true;
  /*for(let i=0; i < indices.length; i++) {
    const account_state =
      wlf_item.items[indices[i]].account_state;
    if (!ACCT_DELETABLE(account_state)) {
      result = false;
    }
  }*/
  return result;
}

const can_delete_acct_fn = (component, wlf_item, item_index) => {
  const is_dev = is_development_mode(component.props.config);
  const item = wlf_item.items[item_index];
  const is_last = item.acct_index === item.user.accounts.length - 1;
  const account_state = item.account_state;
  return is_last
    && (ACCT_DELETABLE(account_state) || is_dev)
    && item.user.accounts.length > 1;
}

const maybe_render_admin_dev_popup = (component, wlf_item, item_index) => {

  if (item_index !== component.state.show_admin_menu) {
    return null;
  }
  const user_indices = collect_user_indices(component, wlf_item, item_index);
  const can_delete_user = can_delete_user_fn(component, wlf_item, user_indices);
  const can_delete_acct = can_delete_acct_fn(component, wlf_item, item_index);

  const buttons = [
    { id: "delete_user", label: "Delete User", disable: !can_delete_user },
    { id: "delete_acct", label: "Delete Account", disable: !can_delete_acct },
  ];

  return render_popup(component, buttons, "admin_menu");
}

const get_date = (metadata, prop) => {
  if (!metadata || !metadata[prop]) {
    return "---";
  }
  const [ yy, mm, dd ] = metadata[prop].split("-");
  return mm + "/" + dd + "/" + yy;
}

const parse_date = sec_ms => {
  if (!Number.isInteger(sec_ms)) {
    return "NO TIMESTAMP";
  }
  const date = new Date(sec_ms);
  return sprintf("%04d-%02d-%02d %02d:%02d:%02d",
    date.getFullYear(), date.getMonth() + 1, date.getDate(),
    date.getHours(), date.getMinutes(), date.getSeconds());
}

const ArrowUp = () => (<i className="fa fa-arrow-up"/>);
const ArrowDown = () => (<i className="fa fa-arrow-down"/>);

const DEFAULT_COL = "Email";

const on_header_click = (component, col) => () => {
    // if selected column is default
  if (col === DEFAULT_COL) {
    // if component state is equal to default
    if (component.state.sort_column === DEFAULT_COL) {
        // set sort descending to opposing
      component.setState({
        sort_descending: !component.state.sort_descending,
      });
    } else {
        // if component state is not default but selected is default
        // that means prev selected is not default set to asc
      component.setState({
        sort_column: DEFAULT_COL,
        sort_descending: true,
      })
    }

    return;
  }

  // if selected is equal to prrev
  if (col === component.state.sort_column) {
    // sort opposite
    if (component.state.sort_descending) {
      component.setState({
        sort_descending: false,
      })
      // if selected is not equal to prev
      // set to default and sort asc
    } else {
      component.setState({
        sort_descending: true,
        sort_column: DEFAULT_COL,
      })
    }
    return;
  }

  // ? set ascending if found? so selected is not defaul and is not equal to prev
  if (SORTABLE_COLS.includes(col)) {
    component.setState({
      sort_column: col,
      sort_descending: true,
    })
  }
}

const render_headers = (component, cols) => {
  const result = [];
  const sel_style = {
    backgroundColor: "#000",
    color: "#FFF",
    display: "flex",
    padding: "0 1rem",
    cursor: "pointer",
  }
  const fee_cols = [
    "Advisory Fee",
    "Sub Advisory Fee",
  ];
  cols.forEach(col => {
    let info_icon = null;
    if (fee_cols.includes(col)) {
      const id = col.replace(" ", "");
      const text = "Cntrl-Click to reset override";
      info_icon = (<Info id={id} component={component} text={text} />);
    }
    if (component.state.sort_column === col) {
      result.push((
        <div style={sel_style} onClick={on_header_click(component, col)}>
          <div>{col}</div>
          <div style={{flex: "1"}}/>
          <div style={{marginLeft: "1rem"}}>
            { component.state.sort_descending ? <ArrowUp/> : <ArrowDown/> }
          </div>
        </div>));
    } else {
      const style = {
        padding: "0 1rem",
      };
      if (SORTABLE_COLS.includes(col)) {
        style.cursor = "pointer";
      }
      result.push((
        <div
          style={style}
          onClick={on_header_click(component, col)}>
          {col}
          {info_icon}
        </div>
      ));
    }
  });
  return result;
}

const do_sort = (component, data, sort_by) => {
  const header = data[0];
  const rest = data.splice(1);

  if (rest.length !== sort_by.length) {
    return data;
  }

  const full_items = rest.map((item, index) => {
    return {
      orig: item,
      sort: sort_by[index],
      index,
    }
  })

  full_items.sort((a, b) => {
    const mult = component.state.sort_descending ? 1 : -1;
    if (typeof a.sort === "string") {
      return string_cmp(a.sort, b.sort) * mult;
    }
    return (b.sort - a.sort) * mult;
  });
  const row_lut = full_items.map(item => item.index);
  component.setTableRowLut(row_lut);

  return [ header ].concat(full_items.map(item => item.orig));
}


const render_acct_checkbox = (component, curr) => {
  const index = curr.item_index;
  const selected = component.state.selected;
  if (!selected || index >= selected.length) {
    return "**";
  }
  const on_change = () => {
    const new_state = deep_copy(component.state.selected);
    new_state[index].selected = !new_state[index].selected;
    component.setState({ selected: new_state })
  }

  const style = {
    margin: "0.2rem",
  };
  return (
    <input
      id={sprintf("%s-%04d-%d", curr.user.username, curr.acct_index, index)}
      type={"checkbox"}
      style={style}
      checked={selected[index].selected}
      value={selected[index].selected}
      onChange={on_change}/>);
}

const render_all_checkbox = component => {
    if(!component.state.isSuperAdmin) return;

  const on_change = () => {
    const value = !component.state.select_all;
    const new_selected = deep_copy(component.state.selected);
    for(let i=0; i < new_selected.length; i++) {
      new_selected[i].selected = value;
    }
    component.setState({
      select_all: value,
      selected: new_selected,
    })
  }
  const value = component.state.select_all;
  const style = {
    margin: "0.2rem",
  };
  return (
    <input
      type={"checkbox"}
      style={style}
      checked={value}
      value={value}
      onChange={on_change}/>);
}

const WLFUserTable = props => {
  const {component, wlf_item, args} = props;
  
  const do_onboarding = args && args.view === AdminDashboardView.onboarding;
  const do_rebalance_mode = args && args.view === AdminDashboardView.rebalance;
  let data = [];
  const sort_by = [];

  if (do_onboarding) {
    data.push(ONOBARDING_DATA_COLUMNS)
  } 
  else if (do_rebalance_mode) {
    data.push(REBALANCE_REQUESTED_DATA_COLUMNS)
  }
  else {
    data.push([
      render_all_checkbox(component),
      ...render_headers(component, DEFAULT_DATA_COLUMNS),
    ]);
  }

  const render_text = (style, text) => {
    return (
      <div style={style}>
        { text }
      </div>);
  }

  const render_action = (style, text, onClick) => {
    return (
      <Action style={style} onClick={onClick} >
        { text }
      </Action>);
  }

    const render_edit = (textStyle, curr, percentValue, isOverRidden, dollarValue, isDollarOverRide, columnName, columnLabel, name) => {
        const overRiddenStyle = {
            ...textStyle,
            backgroundColor: '#555555',
            color: "yellow",
        };

        const style = isOverRidden || isDollarOverRide ? overRiddenStyle : textStyle;
        const value = isDollarOverRide ? dollarValue : percentValue;
        const unit = isDollarOverRide ? '$' : 'bp';

        return (
            <RenderEdit
                style={style} 
                value={value} 
                curr={curr} 
                token={props.token}
                name={name}
                component={component}
                columnLabel={columnLabel}
                columnName={columnName}
                unit={unit}
                isSuperAdmin={component.state.isSuperAdmin}
            />
        )
    }

  wlf_item.items.forEach((curr, index) => {
    let name;
    if (curr.user.info.role_0_first_name) {
      name = curr.user.info.role_0_first_name
        + " " + curr.user.info.role_0_last_name;
    } else if (curr.onboarding) {
      name = curr.onboarding.role_0_first_name + " "
        + curr.onboarding.role_0_last_name;
    } else {
      name = "UNDEFINED";
    }
    const is_default_sort = component.state.sort_column === DEFAULT_COL && component.state.sort_descending;
    const is_first = curr.acct_index === 0;
    const balance = curr.acct.current_price
      ? dollarToString(curr.acct.current_price) : "---";
    const start_date = get_date(curr.acct, 'start_date');
    const curr_date = get_date(curr.acct, 'current_date');
    const end_date = get_date(curr.acct, 'end_date');
    const total_balance = (curr.show_total || !is_default_sort) && curr.user.current_price
      ? dollarToString(curr.user.current_price) : "---";
    const set_passwd = curr.confirmed ? "yes" : "no";
    const text_style = {
      color: state_to_color(curr.derived_state),
    }
    const acct_style = {
      fontWeight: component.state.show_menu === index ? "bold" : "normal",
      ...text_style,
    }

    const on_acct_click = (ev) => {
      component.onMouseRowClick()(index, ev);
    }

    if (do_onboarding) {
      const ts_date = parse_date(curr.onboarding && curr.onboarding.last_timestamp_ms);
      data.push([
        (<div>
          <div style={acct_style}>{curr.tda_account_number}</div>
          { maybe_render_popup(component, wlf_item, index) }
          { maybe_render_admin_dev_popup(component, wlf_item, index) }
        </div>),
        render_text(text_style,   name),
        render_text(text_style, curr.email),
        render_text(text_style, set_passwd),
        render_text(text_style, AccountTypeLabel(curr.account_type)),
        render_text(text_style, curr.derived_state),
        render_text(text_style, curr.account_state),
        render_text(text_style, ts_date),
      ])
    } 
    else if (do_rebalance_mode) {
      const rebalance_mode_text_style = { color: portfolio_performance_to_color(curr.portfolio_performance) };
      const combined_acct_style = { ...acct_style, ...rebalance_mode_text_style };
      const action_style = { backgroundColor: '#FFFFFF' };
      const rebalance_action_style = { ...action_style, ...(isInBand(curr.portfolio_performance) ? {} : { background: "#FF0000", color: "#FFFFFF" }), };
      const engage_cash_action_style = { ...action_style, ...(isInBand(curr.portfolio_performance) ? { background: "#008000", color: "#FFFFFF" } : {}) };
      data.push([
        (<div>
          <div style={combined_acct_style}>{curr.tda_account_number}</div>
          { maybe_render_popup(component, wlf_item, index) }
          { maybe_render_admin_dev_popup(component, wlf_item, index) }
        </div>),
        render_text(rebalance_mode_text_style, name),
        render_text(rebalance_mode_text_style, curr.acct.cash ? dollarToString(curr.acct.cash.value) : ''),
        render_text(rebalance_mode_text_style, curr.acct.cash ? dollarToString(curr.acct.cash_target) : ''),
        render_text(rebalance_mode_text_style, curr.acct.cash ? dollarToString(curr.acct.cash_to_allocate) : ''),
        render_text(rebalance_mode_text_style, PortfolioPerformanceLabel(curr.portfolio_performance)),
        render_action(rebalance_action_style, REBALANCE_OP.REBALANCE, () => component.onRebalanceClick(curr)),
        render_action(engage_cash_action_style, REBALANCE_OP.ENGAGE_CASH, () => component.onEngageCashClick(curr))
      ])
    }
    else {
      const sort_col = component.state.sort_column;
      const cash_value = (curr.acct.cash && curr.acct.cash.value) || 0.;
      if (sort_col === "Email") {
        sort_by.push(curr.email.toLowerCase());
      } else if (sort_col === "Name") {
        sort_by.push(name);
      } else if (sort_col === "Account Type") {
        sort_by.push(curr.account_type);
      } else if (sort_col === "Account State") {
        sort_by.push(curr.account_state);
      } else if (sort_col === "AUM") {
        sort_by.push(curr.acct.current_price || 0);
      } else if (sort_col === "Total AUM") {
        sort_by.push(curr.user.current_price || 0);
      } else if (sort_col === "Cash") {
        sort_by.push(cash_value);
      }

      data.push([
        render_acct_checkbox(component, curr),
        (<div onClick={on_acct_click}>
          <div style={acct_style}>{curr.tda_account_number}</div>
          { maybe_render_popup(component, wlf_item, index) }
          { maybe_render_admin_dev_popup(component, wlf_item, index) }
        </div>),
        render_text(text_style, (is_first || !is_default_sort) ? name : ""),
        render_text(text_style, (is_first || !is_default_sort) ? curr.email : ""),
        render_text(text_style, AccountTypeLabel(curr.account_type)),
        render_text(text_style, curr.account_state),
        render_text(text_style, dollarToString(cash_value)),
        render_text(text_style, balance),
        render_text(text_style, total_balance),
        render_edit(
            text_style, 
            curr, 
            curr.advisory_fee || 0, 
            curr.advisory_fee_override,
            curr.advisory_usd,
            curr.advisory_usd_override,
            'advisory_fee', 
            'advisory fee', 
            name, 
            index
        ),
        render_edit(
            text_style, 
            curr, 
            curr.sub_advisory_fee || 0, 
            curr.sub_advisory_fee_override,
            curr.sub_advisory_usd,
            curr.sub_advisory_usd_override, 
            'sub_advisory_fee', 
            'sub advisory fee', 
            name, 
            index
        ),
        render_text(text_style, dollarToString(curr.monthly_advisory)),
        render_text(text_style, dollarToString(curr.quarterly_sub_advisory)),
        render_text(text_style, dollarToString(curr.daily_sub_advisory)),
        render_text(text_style, start_date),
        render_text(text_style, curr_date),
        render_text(text_style, end_date),
      ])
    }

  })

  const style_rules = [
    {
      pred: row => {
        if (row === 0) {
          return false;
        }
        return wlf_item.items[row - 1].acct_index === 0;
      },
      style: {
        borderTop: "solid 1px #000",
      }
    },
    {
      pred: row => row > 0 && row - 1 === component.state.selected_row,
      style: {
        borderTop: "solid 1px black",
        borderBottom: "solid 1px black",
      }
    },
    {
      // header row styling
      pred: row => row === 0,
      style: {
        color: '#000000',
        fontWeight: 'bold'
      }
    },
    {
      pred: (row) => row % 2 === 0,
      style: {
        backgroundColor: '#EAEAEA',
      },
    },
    {
      pred: (row, col) => is_action_col(row, col),
      style: {
        borderTop: 'initial',
        backgroundColor: '#FFFFFF'
      },
    },
  ]

  const is_action_col = (row, col) => {
    if(!component.state.isSuperAdmin) return false;
    
    return typeof data[row][col].type === 'function' && data[row][col].type.name === 'Action';
  }

  const title_style = {
    fontSize: "2rem",
    marginBottom: "2rem",
  }
  const downloading = component.state.download_billing;

  const on_add_user = () => {
    component.setState({
      show_add_user_dialog: {
        wlf_id: wlf_item.wlf.id,
      }
    })
  }

  const table_container_style = {
    overflowX: "auto",
    overflowY: "auto",
    height: "40rem",
    resize: "both",
    position: "relative",
  }

  data = do_sort(component, data, sort_by);

  let has_item_selected = false;
  if (component.state.selected) {
    for(let i=0; i < component.state.selected.length; i++) {
      if (component.state.selected[i].selected) {
        has_item_selected = true;
        break;
      }
    }
  }

  const has_proxy = !!wlf_item.items.find(item => item.account_state === AccountState.ONBOARDING_PROXY);
  return (
    <div style={{marginTop: "3rem"}}>
      <div style={title_style} onClick={component.onWlfTitleClick}>{wlf_item.wlf.name}</div>
      {component.state.isSuperAdmin && 
        <React.Fragment>
            <div style={{display: "flex", alignItems: "center"}}>
                <div style={{marginLeft: "0"}}>
                    <Action onClick={component.downloadUserTableCsv(wlf_item.wlf.id)}>
                    <TextLoading
                        label={"Export CSV"}
                        loading={downloading}/>
                    </Action>
                </div>
                <div style={{marginLeft: "2rem"}}>
                    <Action onClick={on_add_user}>
                    Add User
                    </Action>
                </div>
                <div style={{marginLeft: "2rem"}}>
                    <Action onClick={component.downloadSubAdvisoryFeeCsv(wlf_item.wlf.id)}>
                    Sub Advisory Billing CSV
                    </Action>
                </div>
                <div style={{marginLeft: "2rem"}}>
                    <Action onClick={component.downloadAdvisoryFeeCsv(wlf_item.wlf.id)}>
                    Advisory Billing CSV        
                    </Action>
                </div>
                { has_item_selected && 
                    <div style={{marginLeft: "2rem"}}>
                        <Action onClick={component.rebalanceAll}>
                            Rebalance Selected
                        </Action>
                    </div>
                }

                { has_proxy && 
                    <div style={{marginLeft: "2rem"}}>
                        <Action onClick={component.updateProxy}>
                        Update Proxy Onboarding
                        </Action>
                    </div>
                }
            </div>
            {maybe_render_wlf_popup(component)}
            <AddUserModal component={component} wlf={wlf_item.wlf} state={component.state}/>
            <AddUserErrorModal component={component} sName tate={component.state}/>
        </React.Fragment>
      }
      
      
      <div style={{height: "2rem"}}/>
      <div style={table_container_style}>
        <DashboardTable
          tableStyle={{marginTop: "0"}}
          tdStyleLut={style_rules}
          onMouseRowEvent={ component.state.isSuperAdmin ? component.onMouseRowEvent(0) : () => {}}
          data={data}/>
        <div style={{height: "20rem"}}/>
      </div>
    </div>
  )

}

export {WLFUserTable};
